import 'prosemirror-state';
import 'prosemirror-model';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ct-collapse{min-width:267px;margin:8px 0;padding:8px;border-radius:2px}.ct-collapse.active>.ct-collapse-title{padding-bottom:8px}.ct-collapse.active>.ct-collapse-title .ct-collapse-title-text:before{transform:rotate(0deg)}.ct-collapse.active>.ct-collapse-content{display:block;height:auto;padding:8px 24px;border-radius:2px}.ct-collapse .ct-collapse-title{line-height:16px}.ct-collapse .ct-collapse-title>.ct-collapse-title-text{position:relative;padding-left:24px;color:#4d4d4d;font-family:PingFangSC-Medium;font-size:13px;vertical-align:top}.ct-collapse .ct-collapse-title>.ct-collapse-title-text:before{position:absolute;top:2px;left:3px;content:"";width:16px;height:16px;background:url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22        %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%3Csvg t%3D%221526953416889%22 class%3D%22icon%22 style%3D%22%22 viewBox%3D%220 0 1024 1024%22 version%3D%221.1%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22     p-id%3D%223453%22 xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22 width%3D%228%22 height%3D%228%22%3E    %3Cdefs%3E        %3Cstyle type%3D%22text%2Fcss%22%3E%3C%2Fstyle%3E    %3C%2Fdefs%3E    %3Cpath d%3D%22M375.966782 310.02559401L28.2073 642.809787a89.339756 89.339756 0 0 0 0 130.169816 99.323282 99.323282 0 0 0 136.057537 0L512.024319 440.323405 859.7838 773.107597a99.323282 99.323282 0 0 0 136.057538 0 89.339756 89.339756 0 0 0 0-130.169817l-347.759482-332.784192-65.916869-59.389179a105.722978 105.722978 0 0 0-140.281336 0l-65.916869 59.389179z%22          fill%3D%22%23747272%22 p-id%3D%223454%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E") no-repeat 50%;transform:rotate(-180deg);transition:transform .2s;cursor:pointer}.ct-collapse>.ct-collapse-content{height:.1px;padding:0;background:transparent;overflow:hidden}.ProseMirror .ct-collapse{overflow:hidden}.ProseMirror .ct-collapse.active>.ct-collapse-content{display:block;height:auto;border-radius:2px}.ProseMirror .ct-collapse>.ct-collapse-content{display:none;overflow:unset}.ProseMirror .ct-collapse:hover{background-color:#f6f6f6}.ProseMirror .ct-collapse:hover>.ct-collapse-content{background-color:#fff}.ProseMirror .ct-collapse-show.ct-collapse{background-color:#f6f6f6;border:1px solid #ddd}.ProseMirror .ct-collapse-show.ct-collapse>.ct-collapse-content{background-color:#f6f6f6}.ProseMirror .ct-collapse-show.active>.ct-collapse-content{background-color:#fff;border:1px solid #ddd}.ProseMirror-selectednode.ct-collapse{border:1px solid #1c6cdc}.ProseMirror .ct-collapse.ProseMirror-selectednode{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.pm-body-wrapper .ct-collapse-title-text{cursor:pointer}';
styleInject(css_248z);

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function handleClick(e) {
    var $target = e.target;
    if (!$target.closest(".".concat(classNamePrefix("collapse-title")))) return;
    var $collapse = $target.closest(".".concat(classNamePrefix("collapse")));
    var cls = $collapse.classList;
    if (cls.contains("active")) {
        cls.remove("active");
    } else {
        cls.add("active");
    }
    e.stopPropagation();
    e.preventDefault();
}
var collapseRender = function collapseRender() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, collapseRender);
    this.fragmentRender = function(node) {
        node.addEventListener("click", handleClick, false);
    };
    this.fragmentCls = ".".concat(classNamePrefix("collapse"));
    this.config = config;
};

export default collapseRender;
//# sourceMappingURL=render.js.map
